import React, { useContext, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import { PlaceStoreContext } from '../../../../../reducers/Place/PlaceContext';
import { AuthContext } from '../../../../../reducers/Auth/AuthContext';
import RePositionListSmall from '../../../../../components/RePositionListSmall';
import { updateOrderOfCategories } from '../../../../../apis/updateOrderOfCategories';
import { updateOrderOfSubCategories } from '../../../../../apis/updateOrderOfSubCategories';
import { updateOrderOfProducts } from '../../../../../apis/updateOrderOfProducts';
import { updateOrderOfServices } from '../../../../../apis/updateOrderOfServices';
import BarLoader from 'react-spinners/BarLoader';
import { COLORS } from '../../../../../utils/colors';
import PublishButton from '../../../../../components/PublishButton';

const Repositions = (props) => {
  const { reposition, close } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [authState] = useContext(AuthContext);
  const {
    user: { placeId },
  } = authState;

  const [items, setItems] = useState([]);
  const [submiting, setSubmiting] = useState(false);
  const [hasChangeInPositions, sethasChangeInPositions] = useState(false);
  const [positions, setPositions] = useState(null);

  const {
    products: { productId__product },
    categories: { categoryId__category },
    services: { serviceId__service },
  } = placeState;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const newItems = [];
    let itemsToIterate = [];

    if (reposition.type === 'categories') {
      itemsToIterate = categoryId__category;
    } else if (reposition.type === 'subcategories') {
      itemsToIterate = categoryId__category;
    } else if (reposition.type === 'products') {
      itemsToIterate = productId__product;
    } else if (reposition.type === 'services') {
      itemsToIterate = serviceId__service;
    }
    
    for (const itemId in itemsToIterate) {
      const item = itemsToIterate[itemId];
      if (itemId === 'new') continue;
      if (reposition.type === 'categories' && item.nested !== null && item.group === false) continue;
      if (reposition.type === 'categories' && item.type !== reposition.filter) continue;
      if (reposition.type === 'products' && item.category_id !== reposition.filter) continue;
      if (reposition.type === 'subcategories' && item.nested !== reposition.filter) continue;

      newItems[Math.abs(item.position)] = item;
    }

    setItems(newItems.filter((item) => item));

  }, [placeState]);

  useEffect(() => {
    if (positions !== null) {
      sethasChangeInPositions(true)
    }
  }, [positions]);

  const handlePositionChanges = async () => {
    setSubmiting(true);
    const hasPositions = positions !== null;
    if (hasPositions) {
      if (reposition.type === 'categories') {
        await updateOrderOfCategories(placeId, reposition.filter, positions);
      }
      if (reposition.type === 'subcategories') {
        await updateOrderOfSubCategories(placeId, items[0].nested, positions);
      }
      if (reposition.type === 'products') {
        await updateOrderOfProducts(placeId, items[0].category_id, positions);
      }
      if (reposition.type === 'services') {
        await updateOrderOfServices(placeId, positions);
      }
    }
    close();
  }

  if (submiting) return (
    <div style={{ marginTop: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '70vh'}}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <p style={{ margin: 0, paddingBottom: '20px', fontWeight: 'bold' }}>SAVING CHANGES AND PUBLISHING ...</p>
          <BarLoader height={4} width={100} color="#000000" loading={true} />
        </div>
      </div>
    </div>
  )

  if (!reposition || !reposition.type) return null;

  const nestedName = categoryId__category[items[0]?.nested]?.name;
  const categoryName = categoryId__category[items[0]?.category_id]?.name;

  const whatToReposition = reposition.type === 'categories' 
    ? `${reposition.filter} categories`
    : reposition.type === 'subcategories' && nestedName
      ? `sub categories of ${nestedName}`
      : reposition.type === 'products' && categoryName
        ? `${categoryName} category products`
        : reposition.type === 'services'
          ? `Reposition Services`
          : '';

  return (
    <Grid container spacing={2} justify="center" style={{ maxWidth: '500px', marginTop: '20px' }}>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <div>
          <p
            style={{
              fontSize: '0.8rem',
              fontWeight: 'bold',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            {whatToReposition.toUpperCase()}
          </p>
          <p
            style={{
              fontSize: '0.8rem',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            Drag and drop to reposition
          </p>
        </div>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <PublishButton
          name="SAVE CHANGES AND PUBLISH"
          disabled={!hasChangeInPositions}
          onClick={handlePositionChanges}
          style={{ marginBottom: '10px' }}
        />
      </Grid>
      <Grid item xs={12}>
        <RePositionListSmall items={items} setItems={setItems} setPositions={setPositions} />
      </Grid>
    </Grid>
  );
};

export default Repositions;
